import React, { useEffect, useRef, useState } from 'react'
import { TabContext, TabList, TabPanel } from '@material-ui/lab'
import { Box, Checkbox, FormControlLabel, Radio, Tab,Button } from '@mui/material'
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { useSelector, useDispatch } from "react-redux";
import moment from 'moment';
import { getOneTarif } from "../../contractManagement/thunks/getOneTarif"
import { useHistory, useLocation } from 'react-router-dom';
import { setPrixDetails, setSelectedTarifData, setTarifDetail } from '../AppStore/ActionCreator/commonDataAction';
import { getClassData } from '../thunks/getClassData';
import { getOnePrix } from '../thunks/getOnePrix';
import { parseISO, format } from 'date-fns'
import swal from 'sweetalert';
import { putBulkUpdate } from '../thunks/putBulkUpdate';
import { upsertNewClass } from '../thunks/upsertNewClass';
import { getcontracts } from '../../pages/bookingConfirmation/thunks/getcontracts';
import CustomDateInput from '../../components/common components/CustomDateInput';
import { TextField } from '@material-ui/core';
import SpinnerLoader from '../../pages/bookingConfirmation/Utils/spinner';
import { showDetailedErrorSwal } from '../../components/common components/showErrorSwal';
import { normalizeTicketingDateEntries } from '../helpers/normalizeTicketingDateEntries';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const NewClass = () => {
    const isEmpty = (obj) => Object.keys(obj).length === 0;
    const history = useHistory();
    const dispatch = useDispatch();
    const query = useQuery();
    const URLTarifKey = query.get("tariff");
    const URLClassKey = query.get("class");
    const regex = /^(?:\{\s*\*?\s*[A-Z]?(?:\s*,\s*[A-Z])*\s*\}|\*|[A-Z](?:\s*,\s*[A-Z])*)$/;

    // const tarifValues = useSelector((state) => state.commonDataReducer.tarifDetail);
    // useEffect(() => {
    //     const fetchData = async () => {
    //         if (tarifValues?.tarifKey) {
    //             try {
    //                 let data = await getOneTarif(tarifValues.tarifKey);
    //                 if (data.data) {
    //                     setTarifValues(data.data);
    //                 }
    //             } catch (error) {
    //                 console.error('Error fetching tarif data:', error);
    //             }
    //         }
    //     };

    //     fetchData();
    // }, [tarifValues]);

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0 })
    }, [])
    const [tarifValues, setTarifValues] = React.useState({});
    const [classData, setClassData] = React.useState({});
    // const classData = useSelector((state) => state.commonDataReducer.classData);
    const classKeys = useSelector((state)=>state.commonDataReducer.classKeys);
    let ticketRules = classData?.ticketingRules;
    let accountCode = classData?.accountCode;
    let ticketDesignator = classData?.ticketDesignator;
    let optionDates = ticketRules?.optionDates;
    let ticketDates = ticketRules?.ticketDates;
    let remarks = classData?.remarks;
    let prixData = tarifValues?.prix;
    const [createNew, setCreateNew] = useState(false)
    const [updateLoader, setUpdateLoader] = useState(false)
    const [value, setValue] = React.useState('1');
    const [isEdit, setIsEdit] = React.useState(() => createNew);
    const [loader, setLoader] = useState(false);
    const [prixApiCallLoader, setPrixApiCallLoader] = useState(false)
    const [prixArray, setPrixArray] = useState([])
    const optionDate = {
        departureWindow: '',
        daysAfterReservation: '',
        daysBeforeDeparture: ''
    }
    const ticketDate = {
        departureWindow: '',
        daysAfterReservation: '',
        daysBeforeDeparture: ''
    }
    const [mandatoryFields, setMandatoryFields] = React.useState({
        "classes": false,
        // "brand": false,
        "fareType": false,
        "classEDRDate": false,
        "searchFareBy": false
    })

    const [formatFields, setFormatFields] = React.useState({
        "classes": false
    })
    const [allTextFields, setAllTextFields] = React.useState({
        "classes": true,
        'brand': true,
        'classNote': true,
        'ticketingFee': true,
        'classCodeDesc': true,
        'infBelow': true,
        'childAge': true,
        'departureWindow': true,
        'daysAfterReservation': true,
        'daysBeforeDeparture': true,
        'accountIntair': true,
        'accountSkyline': true,
        'accountDFW': true,
        'accountSUNFUN': true,
        'accountTC': true,
        'ticketIntair': true,
        'ticketSkyline': true,
        'ticketDFW': true,
        'ticketSUNFUN': true,
        'ticketTC': true,
        'category': true,

    })
    const [classesArray, setClassesArray] = useState([])
    const [currentClassIndex, setCurrentClassIndex] = useState(0)
    
    useEffect(() => {
        if (URLTarifKey && URLClassKey) {
            setCreateNew(false)
            setIsEdit(false)
            getData()
        } else if (URLTarifKey) {
            setCreateNew(true)
            setIsEdit(true)
            getData()
        }
    }, [URLTarifKey, URLClassKey]);

    const getData = async () => {
        setLoader(true)
        let tarifDetails = await getOneTarif(URLTarifKey);
        if (tarifDetails.data) {
            setTarifValues(tarifDetails.data);
        }
        if (URLClassKey) {
            let classDetails = await getClassData(URLClassKey);
            if (classDetails) {
                setClassData(classDetails);
            }
        }
        setLoader(false)
    }

    const [classValues, setClassValues] = React.useState({
        clasKey: "",
        classes: "",
        brand: "",
        fareType: "",
        category: "",
        ticketingFee: "",
        classNote: "",
        classEDRDate: "",
        minMaxStay: "",
        infBelow: "",
        infApplicableOn: "",
        noTicketForInf: false,
        childAge: "",
        juniorAgeFrom: 0,
        juniorAgeTo: 0,
        osi: "",
        branchFiles: false,
        optionDates: [optionDate],
        optionDepartureWindow: "",
        optionDAR: "",
        optionDBR: "",
        ticketDates: [ticketDate],
        ticketDepartureWindow: "",
        ticketDAR: "",
        ticketDBR: "",
        maxOptionDFW: "",
        maxOptionFUN: "",
        maxOptionSKY: "",
        maxOptionTC: "",
        maxOptionVIT: "",
        issueAsBulk: false,
        searchFareBy: "",
        accountIntair: "",
        accountSkyline: "",
        accountDFW: "",
        accountSUNFUN: "",
        accountTC: "",
        ticketIntair: "",
        ticketSkyline: "",
        ticketDFW: "",
        ticketSUNFUN: "",
        ticketTC: "",
        enRemarkIntair: "",
        enRemarkSkyline: "",
        enRemarkDFW: "",
        enRemarkSUNFUN: "",
        enRemarkTC: "",
        frRemarkIntair: "",
        frRemarkSkyline: "",
        frRemarkDFW: "",
        frRemarkSUNFUN: "",
        frRemarkTC: "",
        disableAutoTicketing: false,
        disablePriceUnitConcept: false,
        remarksEn: "",
        remarksFr: "",
        disallowedAirports: "",
        classRoutings: "",
        otherClassOfServices: "",
        classCodeDesc: ""
      });
      
      // Update once API data is available
      React.useEffect(() => {
        if (!classData) return;
      
        setClassValues({
          clasKey: classData.clasKey || "",
          classes: classData.classCodes?.join(", ") || "",
          brand: classData.brandCode,
          fareType: classData.contractType || "",
          category: classData.category || "",
          ticketingFee: classData.ticketingFee,
          classNote: classData.classNote || "",
          classEDRDate: classData.classLastTicketingDate || "",
          minMaxStay: classData.minmaxStay || "",
          infBelow: classData.ageRestrictions?.infantAge || "",
          infApplicableOn: classData.ageRestrictions?.infantAgeApplicableOn || "",
          noTicketForInf: classData.ageRestrictions?.noTicketingForInfant || false,
          childAge: classData.ageRestrictions?.childAge || "",
          juniorAgeFrom: classData.juniorAgeFrom || 0,
          juniorAgeTo: classData.juniorAgeTo || 0,
          osi: classData.osi || "",
          branchFiles: classData.permitBranchPNR || false,
          optionDates: ticketRules?.optionDates || [optionDate],
          optionDepartureWindow: optionDates?.departureWindow || "",
          optionDAR: optionDates?.daysAfterReservation || "",
          optionDBR: optionDates?.daysBeforeDeparture || "",
          ticketDates: ticketRules?.ticketDates || [ticketDate],
          ticketDepartureWindow: ticketDates?.departureWindow || "",
          ticketDAR: ticketDates?.daysAfterReservation || "",
          ticketDBR: ticketDates?.daysBeforeDeparture || "",
          maxOptionDFW: ticketRules?.maxOptionDFW || "",
          maxOptionFUN: ticketRules?.maxOptionFUN || "",
          maxOptionSKY: ticketRules?.maxOptionSKY || "",
          maxOptionTC: ticketRules?.maxOptionTC || "",
          maxOptionVIT: ticketRules?.maxOptionVIT || "",
          issueAsBulk: classData.issueAsBulk || false,
          searchFareBy: classData.fareType || "",
          accountIntair: accountCode?.VIT,
          accountSkyline: accountCode?.SKY,
          accountDFW: accountCode?.DFW,
          accountSUNFUN: accountCode?.FUN,
          accountTC: accountCode?.TC,
          ticketIntair: ticketDesignator?.VIT,
          ticketSkyline: ticketDesignator?.SKY,
          ticketDFW: ticketDesignator?.DFW,
          ticketSUNFUN: ticketDesignator?.FUN,
          ticketTC: ticketDesignator?.TC,
          enRemarkIntair: remarks?.VIT?.english,
          enRemarkSkyline: remarks?.SKY?.english,
          enRemarkDFW: remarks?.DFW?.english,
          enRemarkSUNFUN: remarks?.FUN?.english,
          enRemarkTC: remarks?.TC?.english,
          frRemarkIntair: remarks?.VIT?.French,
          frRemarkSkyline: remarks?.SKY?.French,
          frRemarkDFW: remarks?.DFW?.French,
          frRemarkSUNFUN: remarks?.FUN?.French,
          frRemarkTC: remarks?.TC?.French,
          disableAutoTicketing: classData.disableAutoTicketing,
          disablePriceUnitConcept: classData.disablePriceUnitConcept,
          remarksEn: classData.remarksEn,
          remarksFr: classData.remarksFr,
          disallowedAirports: classData.disallowedAirports?.join(", ") || "",
          classRoutings: classData.classRoutings,
          otherClassOfServices: classData.otherClassOfServices,
          classCodeDesc: classData.classCodeDesc
        });
      }, [classData, ticketRules, optionDates, ticketDates, accountCode, ticketDesignator, remarks]);
      

    const handleChange = async (event, newValue) => {
        setValue(newValue);
        if (newValue == "4" && !createNew) {
            setPrixApiCallLoader(true)
            const classes = await getcontracts({ "clasKey": classData?.clasKey })
            setPrixApiCallLoader(false)
            setPrixArray(classes?.tarifs[0]?.classes?.[0]?.prix)
        }
    }

    const handleStateChange = (event) => {
        let { name, value } = event.target;
        let copyMandatoryFields = { ...mandatoryFields };
        if (copyMandatoryFields[name]) {
            copyMandatoryFields[name] = false;
            setMandatoryFields({ ...copyMandatoryFields })
        }
        let copyFormatFields = { ...formatFields };
        if (copyFormatFields.hasOwnProperty(name)) {
            if (name == "classes") {
                value = value?.toUpperCase();
                copyFormatFields[name] = regex.test(value) ? false : true;
            } else {
                copyFormatFields[name] = value.length && value.length > 0 ? false : true;
            }
            setFormatFields({ ...copyFormatFields })
        }
        if (allTextFields[name]) {
            value = value?.toUpperCase();
        }
        setClassValues(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const handleTarifClick = async () => {
        if (tarifValues?.tarifKey) {
        //     let tarifDetails = await getOneTarif(tarifValues?.tarifKey)
        //     if (tarifDetails?.data) {
        //         dispatch(setTarifDetail(tarifDetails?.data))
                history.push(`/newTariff?tariff=${tarifValues?.tarifKey}`)
            // }
        }
    }

    const cancelClick = () => {
        if (createNew) {
            history.goBack();
        } else {
            setIsEdit(false);
        }
        // setTarif({...tarifDetails})
    }

    const changeOptionTicket = (e, type, index) => {
        let data = { ...classValues };
        if (type == "option") {
            let optionData = data.optionDates[index];
            let name = e.target.name;
            let value = e.target.value.toUpperCase();
            optionData[name] = value;
            data.optionDates[index] = optionData

        } else if (type == "ticket") {
            let optionData = data.ticketDates[index];
            let name = e.target.name;
            let value = e.target.value.toUpperCase();
            optionData[name] = value;
            data.ticketDates[index] = optionData
        }
        setClassValues(data);
    }

    const handleAddTicketDate = () => {
        setClassValues(prev => ({
            ...prev,
            ticketDates: [
                ...prev.ticketDates,
                {
                    departureWindow: '',
                    daysAfterReservation: '',
                    daysBeforeDeparture: ''
                }
            ]
        }));
    };

    const handleRemoveTicketDate = (index) => {
        const updatedTicketDates = [...classValues.ticketDates];
        updatedTicketDates.splice(index, 1);

        setClassValues(prev => ({
            ...prev,
            ticketDates: updatedTicketDates
        }));
    };

    const handleAddOptionDate = () => {
        setClassValues(prev => ({
            ...prev,
            optionDates: [
                ...prev.optionDates,
                {
                    departureWindow: '',
                    daysAfterReservation: '',
                    daysBeforeDeparture: ''
                }
            ]
        }));
    };

    const handleRemoveOptionDate = (index) => {
        const updatedOptionDates = [...classValues.optionDates];
        updatedOptionDates.splice(index, 1);

        setClassValues(prev => ({
            ...prev,
            optionDates: updatedOptionDates
        }));
    };

    const prixDetailsOnclick = async (prixKey, classValue, tarifValue) => {
        // let classDetails = await getClassData(classValue?.clasKey);
        // dispatch(setClassData(classDetails))
        // let tarifValues = { ...classValue, ...tarifValue }
        // dispatch(setSelectedTarifData(tarifValues))
        // const prixDetails = await getOnePrix(prixKey)
        // dispatch(setPrixDetails(prixDetails?.data))
        history.push(`/newPrix?tariff=${tarifValue?.tarifKey}+&class=${classValue?.clasKey}+&prix=${prixKey}`)
        // window.open(`/newPrix?tariff=${tarifValue?.tarifKey}+&class=${classValue?.clasKey}+&prix=${prixKey}`, "_blank");
    }

    const saveClass = async () => {
        const classData = {
            classCodes: classValues.classes ? `{${classValues.classes.replace(/\s+/g, '')}}` : undefined,
            brandCode: classValues.brand || undefined,
            contractType: classValues.fareType || undefined,
            category: classValues.category || undefined,
            ticketingFee: classValues.ticketingFee || undefined,
            classNote: classValues.classNote || undefined,
            classLastTicketingDate: classValues.classEDRDate || undefined,
            minmaxStay: classValues.minMaxStay || undefined,
            ageRestrictions: {
                infantAge: classValues.infBelow || undefined,
                infantAgeApplicableOn: classValues.infApplicableOn || undefined,
                noTicketingForInfant: classValues.noTicketForInf || undefined,
                childAge: classValues.childAge || undefined
            },
            juniorAgeFrom: classValues.juniorAgeFrom || undefined,
            juniorAgeTo: classValues.juniorAgeTo || undefined,
            osi: classValues.osi || undefined,
            permitBranchPNR: classValues.branchFiles || undefined,
            ticketingRules: {
                optionDates: classValues.optionDates?.length
                    ? normalizeTicketingDateEntries(classValues.optionDates)
                    : undefined,
                ticketDates: classValues.ticketDates?.length
                    ? normalizeTicketingDateEntries(classValues.ticketDates)
                    : undefined,
                maxOptionDFW: classValues.maxOptionDFW || undefined,
                maxOptionFUN: classValues.maxOptionFUN || undefined,
                maxOptionSKY: classValues.maxOptionSKY || undefined,
                maxOptionTC: classValues.maxOptionTC || undefined,
                maxOptionVIT: classValues.maxOptionVIT || undefined
            },
            issueAsBulk: classValues.issueAsBulk || undefined,
            fareType: classValues.searchFareBy || undefined,
            accountCode: {
                VIT: classValues.accountIntair || null,
                SKY: classValues.accountSkyline || null,
                DFW: classValues.accountDFW || null,
                FUN: classValues.accountSUNFUN || null,
                TC: classValues.accountTC || null
            },
            ticketDesignator: {
                VIT: classValues.ticketIntair || undefined,
                SKY: classValues.ticketSkyline || undefined,
                DFW: classValues.ticketDFW || undefined,
                FUN: classValues.ticketSUNFUN || undefined,
                TC: classValues.ticketTC || undefined
            },
            remarks: {
                VIT: {
                    english: classValues.enRemarkIntair || undefined,
                    French: classValues.frRemarkIntair || undefined
                },
                SKY: {
                    english: classValues.enRemarkSkyline || undefined,
                    French: classValues.frRemarkSkyline || undefined
                },
                DFW: {
                    english: classValues.enRemarkDFW || undefined,
                    French: classValues.frRemarkDFW || undefined
                },
                FUN: {
                    english: classValues.enRemarkSUNFUN || undefined,
                    French: classValues.frRemarkSUNFUN || undefined
                },
                TC: {
                    english: classValues.enRemarkTC || undefined,
                    French: classValues.frRemarkTC || undefined
                }
            },
            disableAutoTicketing: classValues.disableAutoTicketing || undefined,
            disablePriceUnitConcept: classValues.disablePriceUnitConcept || undefined,
            remarksEn: classValues.remarksEn || undefined,
            remarksFr: classValues.remarksFr || undefined,
            disallowedAirports: classValues.disallowedAirports ? classValues.disallowedAirports.split(", ") : undefined,
            classRoutings: classValues.classRoutings || undefined,
            otherClassOfServices: classValues.otherClassOfServices ? classValues.otherClassOfServices.trim() : undefined,
            classCodeDesc: classValues.classCodeDesc || undefined
        };
        setUpdateLoader(true)
        const payload = {
            "classKeys": classValues.clasKey ? [classValues.clasKey] : undefined,
            classData
        }
        const tarifData = {
            clasTarifKey: tarifValues.tarifKey,
        }
        const finalClassData = cleanObject(payload?.classData)
        // const finalPayload = {...payload,["classData"]:finalClassData}
        // const bulkUpdateResponse = await putBulkUpdate(finalPayload)
        const finalPayload = [{ ...classData, ...tarifData, "clasKey": classValues?.clasKey ? classValues?.clasKey : undefined }];

        // Check if all mandatory fields are entered;
        let copyMandatoryFields = { ...mandatoryFields };
        Object.keys(copyMandatoryFields).forEach((field) => {
            if (field == "isBrandedFare") {
                copyMandatoryFields[field] = classValues.hasOwnProperty('isBrandedFare') ? false : true;
            } else {
                copyMandatoryFields[field] = classValues[field]?.length && classValues[field]?.length > 0 ? false : true;
            }
        });
        setMandatoryFields({ ...copyMandatoryFields })
        const missingFields = Object.keys(copyMandatoryFields).filter((field) => copyMandatoryFields[field]);

        if (missingFields.length > 0) {
            setUpdateLoader(false);
            swal({
                text: "Please fill all the required fields.",
                icon: "error",
                button: "Close",
                timer: 2000,
            })
            return;
        }

        const formatField = Object.keys(formatFields).filter((field) => formatFields[field]);

        if (formatField.length > 0) {
            setUpdateLoader(false);
            swal({
                text: "Please fill all the fields in proper format.",
                icon: "error",
                button: "Close",
                timer: 2000,
            })
            return;
        }


        const bulkUpdateResponse = await upsertNewClass(finalPayload)
        setUpdateLoader(false)
        if (bulkUpdateResponse?.status == "Success") {
            swal({
                text: createNew ? "Class created successfully!" : "Class updated successfully!",
                icon: "success",
                button: "Close",
                timer: 2000,
            })
            let key = bulkUpdateResponse?.keys?.[0];
            if (key) {
                history.push(`/newClass?tariff=${URLTarifKey}&class=${key}`);
            }
        } else {
            // swal({
            //     text: bulkUpdateResponse?.message,
            //     icon: "error",
            //     button: "Close",
            //     timer: 2000,
            // })
            showDetailedErrorSwal({
                message: bulkUpdateResponse?.message,
                errorDetails: bulkUpdateResponse?.errorDetails
            });
        }
    }

    const createNewClasses = () => {
        console.log('New Classes are created! ', classValues)
    }

    const createMultipleClasses = () => {
        createNewClasses();

    }

    const createNewClassAndNewPrix = () => {
        createNewClasses();
        dispatch(setPrixDetails({}))
        history.push('/newPrix');
    }

    function cleanObject(obj) {
        if (obj === null || typeof obj !== 'object') {
            return obj;
        }

        if (Array.isArray(obj)) {
            return obj
                .map(cleanObject)
                .filter(item => item !== null && item !== undefined && item !== ""); // Remove unwanted items
        }

        const cleanedObj = {};

        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                const value = obj[key];
                if (value !== null && value !== undefined && value !== "") {
                    cleanedObj[key] = cleanObject(value);
                }
            }
        }

        return cleanedObj;
    }

    const handleDateChange = (date) => {
        let copyMandatoryFields = { ...mandatoryFields };
        copyMandatoryFields['classEDRDate'] = false;
        setMandatoryFields({ ...copyMandatoryFields })

        if (date) {
            // const formattedDate = format(date, 'yyyy-MM-dd');
            setClassValues((prevValues) => ({
                ...prevValues,
                classEDRDate: date,
            }));
        }
    };
    console.log("classValues", classValues, classValues?.classEDRDate)

    const tariffKeyRef = useRef(URLTarifKey);
    const classKeyRef = useRef(URLClassKey);

    useEffect(() => {
        classKeyRef.current = URLClassKey;
        tariffKeyRef.current = URLTarifKey;

    }, [URLClassKey,URLTarifKey]);

    const handleNextClass = async() => {
        if (classKeyRef.current && (!createNew)) {
            let currentIndex = classKeys.findIndex(item => item == classKeyRef.current);
            const nextIndex = currentIndex + 1;
            if (classKeys[nextIndex]) {
                let newClassKey = classKeys[nextIndex];
                const response = await getcontracts({ "clasKey": newClassKey.trim() })
                let tarifKey = response?.tarifs[0]?.tarifKey;
                if (newClassKey && tarifKey) {
                    history.push(`/newClass?tariff=${tarifKey}&class=${newClassKey}`);
                }
            }
        }

    };

    const handlePreviousClass = async() => {
        if (classKeyRef.current && (!createNew)) {
            let currentIndex = classKeys.findIndex(item => item == classKeyRef.current);
            const prevIndex = currentIndex - 1;
            if (classKeys[prevIndex]) {
                let newClassKey = classKeys[prevIndex];
                const response = await getcontracts({ "clasKey": newClassKey.trim() })
                let tarifKey = response?.tarifs[0]?.tarifKey;
                if (newClassKey && tarifKey) {
                    history.push(`/newClass?tariff=${tarifKey}&class=${newClassKey}`);
                }
            }
        }
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.ctrlKey && event.key === "ArrowRight") {
                event.preventDefault();
                handleNextClass();
            } else if (event.ctrlKey && event.key === "ArrowLeft") {
                event.preventDefault();
                handlePreviousClass();
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, []);

    const createDuplicate = async () => {
        if(updateLoader) return;
        const classData = {
            classCodes: classValues.classes ? `{${classValues.classes.replace(/\s+/g, '')}}` : undefined,
            brandCode: classValues.brand || undefined,
            contractType: classValues.fareType || undefined,
            category: classValues.category || undefined,
            ticketingFee: classValues.ticketingFee || undefined,
            classNote: classValues.classNote || undefined,
            classLastTicketingDate: classValues.classEDRDate || undefined,
            minmaxStay: classValues.minMaxStay || undefined,
            ageRestrictions: {
                infantAge: classValues.infBelow || undefined,
                infantAgeApplicableOn: classValues.infApplicableOn || undefined,
                noTicketingForInfant: classValues.noTicketForInf || undefined,
                childAge: classValues.childAge || undefined
            },
            juniorAgeFrom: classValues.juniorAgeFrom || undefined,
            juniorAgeTo: classValues.juniorAgeTo || undefined,
            osi: classValues.osi || undefined,
            permitBranchPNR: classValues.branchFiles || undefined,
            ticketingRules: {
                optionDates: classValues.optionDates?.length
                    ? normalizeTicketingDateEntries(classValues.optionDates)
                    : undefined,
                ticketDates: classValues.ticketDates?.length
                    ? normalizeTicketingDateEntries(classValues.ticketDates)
                    : undefined,
                maxOptionDFW: classValues.maxOptionDFW || undefined,
                maxOptionFUN: classValues.maxOptionFUN || undefined,
                maxOptionSKY: classValues.maxOptionSKY || undefined,
                maxOptionTC: classValues.maxOptionTC || undefined,
                maxOptionVIT: classValues.maxOptionVIT || undefined
            },
            issueAsBulk: classValues.issueAsBulk || undefined,
            fareType: classValues.searchFareBy || undefined,
            accountCode: {
                VIT: classValues.accountIntair || undefined,
                SKY: classValues.accountSkyline || undefined,
                DFW: classValues.accountDFW || undefined,
                FUN: classValues.accountSUNFUN || undefined,
                TC: classValues.accountTC || undefined
            },
            ticketDesignator: {
                VIT: classValues.ticketIntair || undefined,
                SKY: classValues.ticketSkyline || undefined,
                DFW: classValues.ticketDFW || undefined,
                FUN: classValues.ticketSUNFUN || undefined,
                TC: classValues.ticketTC || undefined
            },
            remarks: {
                VIT: {
                    english: classValues.enRemarkIntair || undefined,
                    French: classValues.frRemarkIntair || undefined
                },
                SKY: {
                    english: classValues.enRemarkSkyline || undefined,
                    French: classValues.frRemarkSkyline || undefined
                },
                DFW: {
                    english: classValues.enRemarkDFW || undefined,
                    French: classValues.frRemarkDFW || undefined
                },
                FUN: {
                    english: classValues.enRemarkSUNFUN || undefined,
                    French: classValues.frRemarkSUNFUN || undefined
                },
                TC: {
                    english: classValues.enRemarkTC || undefined,
                    French: classValues.frRemarkTC || undefined
                }
            },
            disableAutoTicketing: classValues.disableAutoTicketing || undefined,
            disablePriceUnitConcept: classValues.disablePriceUnitConcept || undefined,
            remarksEn: classValues.remarksEn || undefined,
            remarksFr: classValues.remarksFr || undefined,
            disallowedAirports: classValues.disallowedAirports ? classValues.disallowedAirports.split(", ") : undefined,
            classRoutings: classValues.classRoutings || undefined,
            otherClassOfServices: classValues.otherClassOfServices ? classValues.otherClassOfServices.trim() : undefined,
            classCodeDesc: classValues.classCodeDesc || undefined
        };
        setUpdateLoader(true)
        const payload = {
            "classKeys": classValues.clasKey ? [classValues.clasKey] : undefined,
            classData
        }
        const tarifData = {
            clasTarifKey: tarifValues.tarifKey,
        }

        const finalPayload = [{ ...classData, ...tarifData, "clasKey": undefined }];

        // Check if all mandatory fields are entered;
        let copyMandatoryFields = { ...mandatoryFields };
        Object.keys(copyMandatoryFields).forEach((field) => {
            if (field == "isBrandedFare") {
                copyMandatoryFields[field] = classValues.hasOwnProperty('isBrandedFare') ? false : true;
            } else {
                copyMandatoryFields[field] = classValues[field]?.length && classValues[field]?.length > 0 ? false : true;
            }
        });
        setMandatoryFields({ ...copyMandatoryFields })
        const missingFields = Object.keys(copyMandatoryFields).filter((field) => copyMandatoryFields[field]);

        if (missingFields.length > 0) {
            setUpdateLoader(false);
            swal({
                text: "Please fill all the required fields.",
                icon: "error",
                button: "Close",
                timer: 2000,
            })
            return;
        }

        const formatField = Object.keys(formatFields).filter((field) => formatFields[field]);

        if (formatField.length > 0) {
            setUpdateLoader(false);
            swal({
                text: "Please fill all the fields in proper format.",
                icon: "error",
                button: "Close",
                timer: 2000,
            })
            return;
        }


        const bulkUpdateResponse = await upsertNewClass(finalPayload)
        setUpdateLoader(false)
        if (bulkUpdateResponse?.status == "Success") {
            swal({
                text: "Class duplicated successfully!",
                icon: "success",
                button: "Close",
                timer: 2000,
            })
            let key = bulkUpdateResponse?.keys?.[0];
            if (key) {
                history.push(`/newClass?tariff=${URLTarifKey}&class=${key}`);
            }
        } else {
            // swal({
            //     text: bulkUpdateResponse?.message,
            //     icon: "error",
            //     button: "Close",
            //     timer: 2000,
            // })
            showDetailedErrorSwal({
                message: bulkUpdateResponse?.message,
                errorDetails: bulkUpdateResponse?.errorDetails
            });
        }
    }

    useEffect(() => {
        if(tarifValues?.isBrandedFare == 0){
            setClassValues(prev => ({
                ...prev,
                brand: "NB"
            }) )
        }

    },[tarifValues])

    return (
        <>
            {loader ?
                <>
                    <div className="col-md-12 text-center mt-3">

                        <SpinnerLoader />
                    </div>
                </>
            :
            <>
            <div className="cm-head-2">
                <div className={"d-flex justify-content-between"}>
                    <div className='d-flex '>
                        <h5 className="">
                            {createNew ? 'Create Class' : isEdit ?
                                <>
                                    Edit Class
                                </>
                                :
                                <>
                                    Class Details
                                </>
                            }

                        </h5>&nbsp;&nbsp;
                        {(!createNew && (!isEdit)) && <i className="fas fa-edit" style={{ "color": "#0055b8", "cursor": "pointer" }} onClick={() => setIsEdit(!isEdit)}></i>}
                        {/* {(!createNew) &&
                            <span title="Create a Duplicate Class">
                                <i class="fa-solid fa-copy" style={{ "color": "#0055b8", "cursor": "pointer", "marginLeft": "10px" }} onClick={() => createDuplicate()}></i>
                            </span>
                        } */}
                    </div>
                    
                    <div>
                        {createNew ?
                            <>
                                Tariff : <a style={{ "textDecoration": "underline" }} onClick={() => handleTarifClick()}>{tarifValues?.tarifKey}</a>
                            </>
                            :
                            <>
                                Class: {classValues?.clasKey}&nbsp;  Tariff : <a style={{ "textDecoration": "underline" }} onClick={() => handleTarifClick()}>{tarifValues?.tarifKey}</a>
                            </>
                        }
                    </div>
                </div>

            </div> 

            <div className="Tariff__Section Class__Section">
                <div>

                    <div className="card Tariff__BorderB">
                        <div className="card-body">
                            
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6 cm-col">
                                            {/* <label className="cm-head-label">Carrier</label>
                                            <label>{tarifValues?.carrier}</label> */}
                                            <TextField
                                                className="cm-input autoCapitalise custom-disabled-field"
                                                value={tarifValues?.carrier}
                                                disabled={true}
                                                name='Carrier'
                                                label="Carrier"
                                            />

                                        </div>
                                        <div className="col-md-6 cm-col">
                                            {/* <label className="cm-head-label">Origin</label>
                                            <label>{tarifValues?.origins}</label> */}
                                            <TextField
                                                className="cm-input autoCapitalise custom-disabled-field"
                                                value={tarifValues?.origins}
                                                disabled={true}
                                                name='Origin'
                                                label="Origin"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6 cm-col">
                                            {/* <label className="cm-head-label">Destination</label>
                                            <label>{tarifValues?.destinations}</label> */}
                                            <TextField
                                                className="cm-input autoCapitalise custom-disabled-field"
                                                value={tarifValues?.destinations}
                                                disabled={true}
                                                name='Destination'
                                                label="Destination"
                                            />

                                        </div>
                                        <div className="col-md-6 cm-col">
                                            {/* <label className="cm-head-label">Trip Type</label>
                                            <label>{tarifValues?.tripType == "OW" ? "One Way" : "Not One Way"}</label> */}
                                            <TextField
                                                className="cm-input autoCapitalise custom-disabled-field"
                                                value={tarifValues?.tripType == "OW" ? "One Way" : "Not One Way"}
                                                disabled={true}
                                                name='Trip Type'
                                                label="Trip Type"
                                            />
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className="row">
                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6 cm-col">
                                            {/* <label className="cm-head-label">Contract Type</label>
                                            <label>{tarifValues.cruiseFare == 1 ? "Cruise" : tarifValues.landFare == 1 ? "Land" : "Air"}</label> */}
                                            <TextField
                                                className="cm-input autoCapitalise custom-disabled-field"
                                                value={tarifValues.cruiseFare == 1 ? "Cruise" : tarifValues.landFare == 1 ? "Land" : "Air"}
                                                disabled={true}
                                                name='Contract Type'
                                                label="Contract Type"
                                            />

                                        </div>
                                        <div className="col-md-6 cm-col">
                                            <label className="cm-head-label">Fare Type <span className='bd-errorMsg'>*</span></label>
                                            <div className="cm-radio-inline custom-disabled-field">
                                                <FormControlLabel control={<Radio color="primary" checked={classValues?.fareType == "Published" ? true : false} disabled={!isEdit} name='fareType' value='Published' onChange={handleStateChange} />} label="(%) Published" />
                                                <FormControlLabel control={<Radio color="primary" checked={classValues?.fareType == "Net" ? true : false} disabled={!isEdit} name='fareType' value='Net' onChange={handleStateChange} />} label="($) Net" />
                                            </div>
                                            {mandatoryFields?.fareType &&
                                                <div className='bd-errorMsg'>This field is required.</div>
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6 cm-col">
                                            {/* <label className="cm-head-label">Branded Fare</label>
                                            <label>{tarifValues?.isBrandedFare == 1 ? "Yes" : "No"}</label> */}
                                            {/* <TextField
                                                className="cm-input autoCapitalise custom-disabled-field"
                                                value={tarifValues?.isBrandedFare == 1 ? "Yes" : "No"}
                                                disabled={true}
                                                name='Branded Fare'
                                                label="Branded Fare"
                                            /> */}
                                            <label className="cm-head-label">Branded Fare</label>
                                            <div className="cm-radio-inline custom-disabled-field">
                                                <FormControlLabel control={<Radio color="primary" checked={tarifValues?.isBrandedFare == 1} disabled={true} />} label="Yes" />
                                                <FormControlLabel control={<Radio color="primary" checked={tarifValues?.isBrandedFare == 0} disabled={true} />} label="No" />
                                            </div>

                                        </div>
                                        <div className="col-md-6 cm-col">
                                            {/* <label className="cm-head-label">Cabin Type</label>
                                            <label>{tarifValues.cabinType?.join(', ')}</label> */}
                                            <TextField
                                                className="autoCapitalise custom-disabled-field"
                                                value={tarifValues?.cabinType?.join(', ')}
                                                disabled={true}
                                                name='Cabin Type'
                                                label="Cabin Type"
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </div>
                                    </div>
                                </div>

                            </div>


                            <div className="row mt-4">
                                <div className="col-md-6 cm-col">
                                    <div className="row">
                                        {/* {!createNew && <div className="col-md-6">
                                            <label className="cm-head-label">Class Key</label>

                                            <input
                                                className="form-control cm-input autoCapitalise"
                                                placeholder="Enter Class Key"
                                                value={classValues?.clasKey}
                                                disabled={true}
                                                name='clasKey'
                                                onChange={handleStateChange}
                                            />
                                        </div>} */}
                                        <div className="col-md-6">
                                            {/* <label className="cm-head-label">Classes<span className='bd-errorMsg'>*</span></label> */}
                                            <TextField
                                                className="cm-input autoCapitalise custom-disabled-field"
                                                placeholder="Enter Classes"
                                                value={classValues.classes}
                                                disabled={!isEdit}
                                                name='classes'
                                                onChange={handleStateChange}
                                                label="Classes"
                                                required={true}
                                            />
                                            {mandatoryFields?.classes &&
                                                <div className='bd-errorMsg mt-3'>This field is required.</div>
                                            }
                                            {formatFields?.classes &&
                                                <div className='bd-errorMsg mt-3'>Please enter valid class code.</div>
                                            }
                                        </div>
                                        <div className="col-md-6">

                                            {/* <label className="cm-head-label">Brand <span className='bd-errorMsg'>*</span></label> */}
                                            <TextField
                                                className="cm-input autoCapitalise custom-disabled-field"
                                                placeholder="Enter Brand"
                                                disabled={!isEdit || tarifValues?.isBrandedFare == 0 }
                                                value={classValues.brand}
                                                name='brand'
                                                onChange={handleStateChange}
                                                label="Brand"
                                                inputProps={{ maxLength: 15 }}
                                            />
                                        </div>
                                    </div>
                                </div>



                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6 cm-col">
                                            {/* <label className="cm-head-label">Class Note</label> */}
                                            <TextField
                                                className=" cm-input autoCapitalise custom-disabled-field"
                                                placeholder="Enter Class Note"
                                                value={classValues.classNote}
                                                disabled={!isEdit}
                                                name='classNote'
                                                onChange={handleStateChange}
                                                label="Class Note"
                                            />
                                        </div>
                                        <div className="col-md-6 cm-col">
                                            <CustomDateInput
                                                value={classValues?.classEDRDate || null}
                                                onChange={handleDateChange}
                                                disabled={!isEdit}
                                                label="Class EDR Date"
                                                className="BulkUpdate__DateInput custom-disabled-field"
                                                required={true}
                                            />
                                            {mandatoryFields?.classEDRDate &&
                                                <div className='bd-errorMsg'>This field is required.</div>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">

                                </div>


                            </div>

                            <div className="row">
                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6 cm-col">
                                            {/* <label className="cm-head-label">Category</label> */}
                                            <TextField className="form-control cm-input autoCapitalise custom-disabled-field" placeholder="Enter Category" value={classValues?.category} disabled={!isEdit} name='category' onChange={handleStateChange} inputProps={{ maxLength: 4 }} label='Category'/>
                                        </div>
                                        <div className="col-md-6 cm-col">
                                            {/* <label className="cm-head-label">Ticketing Fee</label> */}
                                            <TextField
                                                className="form-control cm-input autoCapitalise custom-disabled-field"
                                                placeholder="Enter Ticketing Fee"
                                                value={classValues.ticketingFee}
                                                disabled={!isEdit}
                                                name='ticketingFee'
                                                onChange={handleStateChange}
                                                label="Ticketing Fee"
                                            />
                                        </div>

                                    </div>

                                </div>

                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6 cm-col">
                                            {/* <label className="cm-head-label">Class Code Description</label> */}
                                            <TextField className="form-control cm-input autoCapitalise custom-disabled-field" type="text" disabled={!isEdit} value={classValues.classCodeDesc} name='classCodeDesc' onChange={handleStateChange} label='Source'/>
                                        </div>
                                    </div>
                                </div>

                            </div>


                            {/* <div className="row">
                                <div className="col-md-6">
                                    <div className="row">
                                        
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                    <Box sx={{ width: '100%', typography: 'body1' }}>
                        <TabContext value={value}>
                            <Box sx={{ borderBottom: 20, borderColor: '#FFF4DE', background: '#fff' }}>
                                <TabList onChange={handleChange} aria-label="lab API tabs example">
                                    <Tab label="Classes" value="1" />
                                    <Tab label="Price At Sabre" value="2" />
                                    {/* <Tab label="Remarks" value="3" /> */}
                                    <Tab label="Prix" value="4" hidden={createNew} />

                                </TabList>
                            </Box>
                            <TabPanel value="1" className='m-0 p-0'>
                                {/* <div className="card Tariff__BorderB">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">French Description</label>
                                                    <input className="form-control cm-input autoCapitalise" type="text" disabled={!isEdit} value={classValues.remarksFr} name='remarksFr' onChange={handleStateChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">English Description</label>
                                                    <input className="form-control cm-input autoCapitalise" type="text" disabled={!isEdit} value={classValues.remarksEn} name='remarksEn' onChange={handleStateChange} />
                                                </div>
                                            </div>

                                            <div className="col-md-2">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">MinMax Stay</label>
                                                    <input className="form-control cm-input autoCapitalise" type="text" placeholder='Enter Min' disabled={!isEdit} value={classValues.minMaxStay} name='minMaxStay' onChange={handleStateChange} />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div> */}

                                <div className="card Tariff__BorderB">
                                    <div className="card-body">
                                        <div className=" mb-4">
                                            <div className="d-flex justify-content-between">
                                                <span>AGE</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    {/* <label className="cm-head-label">Infant Below</label> */}
                                                    <TextField className="form-control cm-input autoCapitalise custom-disabled-field" type="number" placeholder="Enter Age" disabled={!isEdit} value={classValues.infBelow} name='infBelow' onChange={handleStateChange} label='Infant Below'/>
                                                </div>
                                            </div>

                                            <div className="col-md-3">
                                                <div className="cm-col custom-disabled-field">
                                                    <label className="cm-head-label">Applicable On</label>
                                                    <FormControlLabel control={<Radio color="primary" checked={classValues.infApplicableOn == "DEPARTURE" ? true : false} name='infApplicableOn' value={'DEPARTURE'} onChange={handleStateChange} />} label="Departure" disabled={!isEdit} />
                                                    <FormControlLabel control={<Radio color="primary" checked={classValues.infApplicableOn == "ARRIVAL" ? true : false} name='infApplicableOn' value={'ARRIVAL'} onChange={handleStateChange} />} label="Return" disabled={!isEdit} />
                                                </div>
                                            </div>

                                            {/* <div className="col-md-3">
                                                <div className="cm-col">
                                                    <label className="cm-head-label"></label>
                                                    <FormControlLabel control={<Checkbox color="primary" disabled={!isEdit} checked={(classValues.noTicketForInf == true || classValues.noTicketForInf == "true")} name='noTicketForInf' value={(classValues.noTicketForInf == true || classValues.noTicketForInf == "true" ? false : true)} onChange={handleStateChange} />} label="  No ticket for infant" />
                                                </div>
                                            </div> */}
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    {/* <label className="cm-head-label">Child Below</label> */}
                                                    <TextField className="form-control cm-input autoCapitalise custom-disabled-field" type="number" placeholder="Enter Age" disabled={!isEdit} value={classValues.childAge} name='childAge' onChange={handleStateChange} label='Child From 2 To'/>
                                                </div>
                                            </div>
                                            {/* <div className="col-md-3">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">Junior between</label>
                                                    <div className="d-flex ">
                                                        <div className='classCount mr-2'>
                                                            <button className='classIncress' disabled={!isEdit}
                                                                onClick={() => {
                                                                    const event = { target: { name: 'juniorAgeFrom', value: Math.max(0, classValues.juniorAgeFrom - 1) } };
                                                                    handleStateChange(event);
                                                                }}>-</button>
                                                            <input className="classCountinput" type="number" value={classValues.juniorAgeFrom} disabled={!isEdit} name='juniorAgeFrom' onChange={handleStateChange} />
                                                            <button className='classDecress' disabled={!isEdit}
                                                                onClick={() => {
                                                                    const event = { target: { name: 'juniorAgeFrom', value: classValues.juniorAgeFrom + 1 } };
                                                                    handleStateChange(event);
                                                                }}>+</button>
                                                        </div>
                                                        <div className='classCount'>
                                                            <button className='classIncress' disabled={!isEdit}
                                                                onClick={() => {
                                                                    const event = { target: { name: 'juniorAgeTo', value: Math.max(0, classValues.juniorAgeTo - 1) } };
                                                                    handleStateChange(event);
                                                                }}
                                                            >-</button>
                                                            <input className="classCountinput" type="number" value={classValues.juniorAgeTo} disabled={!isEdit} name='juniorAgeTo' onChange={handleStateChange} />
                                                            <button className='classDecress' disabled={!isEdit}
                                                                onClick={() => {
                                                                    const event = { target: { name: 'juniorAgeTo', value: classValues.juniorAgeTo + 1 } };
                                                                    handleStateChange(event);
                                                                }}>+</button>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div> */}
                                            {/* <div className="col-md-3">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">Senior Above</label>
                                                    <input className="form-control cm-input" type="text" disabled={!isEdit} />
                                                </div>
                                            </div> */}
                                        </div>
                                        <div className=" mb-4">
                                            <div className="d-flex justify-content-between">
                                                <span>Notes for age</span>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12 mb-4">
                                                <span>Infant etkt not allowed with some codeshared flights or interligne carriers.Fees and adv purchase apply for paperticket. Bebe Etkt non permis avec certains vols partages ou interlignes. Frais et delais d achat pour demander un billet papier.</span>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">OSI</label>
                                                    <textarea className="form-control cm-input autoCapitalise custom-disabled-field" style={{ "height": "90px" }} type="text" placeholder='Enter OSI' disabled={!isEdit} value={classValues.osi} name='osi' onChange={handleStateChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="cm-col custom-disabled-field">
                                                    <label className="cm-head-label">Branch Files </label>
                                                    <FormControlLabel control={<Checkbox color="primary" disabled={!isEdit} checked={(classValues.branchFiles == true || classValues.branchFiles == "true")} name='branchFiles' value={(classValues.branchFiles == true || classValues.branchFiles == "true" ? false : true)} onChange={handleStateChange} />} label="Branch files not permitted" />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div className="card Tariff__BorderB">
                                    <div className="card-body">
                                        <div className="cm-head-2 mb-4">
                                            <div className="d-flex justify-content-between">
                                                <span className="">Option Date</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            
                                                    {classValues?.optionDates?.map((item, i) => {
                                                        return (
                                                            <>
                                                                <div className="col-md-3">
                                                                    <div className="cm-col">
                                                                        <TextField label='Departure Window'className="form-control cm-input autoCapitalise custom-disabled-field" type="number" placeholder='Enter Departure Window' disabled={!isEdit} value={item.departureWindow} name='departureWindow' onChange={(e) => changeOptionTicket(e, "option", i)} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <div className="cm-col">
                                                                        <TextField label='Days After Reservation'className="form-control cm-input autoCapitalise custom-disabled-field" type="number" placeholder='Enter Days after reservation' disabled={!isEdit} value={item.daysAfterReservation} name='daysAfterReservation' onChange={(e) => changeOptionTicket(e, "option", i)} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <div className="cm-col">
                                                                        <TextField label='Days Before Departure'className="form-control cm-input autoCapitalise custom-disabled-field" type="number" placeholder='Enter Days before departure' disabled={!isEdit} value={item.daysBeforeDeparture} name='daysBeforeDeparture' onChange={(e) => changeOptionTicket(e, "option", i)} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-3 d-flex align-items-end">
                                                                    {isEdit &&
                                                                        <div className='setD-flex ms-2'>
                                                                            <Button
                                                                                className="BulkUpdate__removeBtn me-2"
                                                                                onClick={() => handleRemoveOptionDate(i)}
                                                                                disabled={classValues.optionDates.length === 1}
                                                                            >
                                                                                <i className="fas fa-trash-alt"></i>
                                                                            </Button>

                                                                            {(i === classValues.optionDates.length - 1 && i<3) && (
                                                                                <Button className='BulkUpdate__AddBtn' onClick={handleAddOptionDate}>
                                                                                    <i className="fas fa-plus-circle"></i>
                                                                                </Button>
                                                                            )}
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </>
                                                        )
                                                    })}
                                                
                                        </div>
                                    </div>
                                </div>

                                <div className="card Tariff__BorderB">
                                    <div className="card-body">
                                        <div className="cm-head-2 mb-4">
                                            <div className="d-flex justify-content-between">
                                                <span className="">Ticket By Date</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            
                                                    

                                                    {classValues?.ticketDates?.map((item, i) => {
                                                        return (
                                                            <>
                                                                <div className="col-md-3">
                                                                    <div className="cm-col">
                                                                        <TextField label='Departure Window' className="form-control cm-input autoCapitalise custom-disabled-field" type="number" placeholder='Enter Departure Window' disabled={!isEdit} value={item.departureWindow} name='departureWindow' onChange={(e) => changeOptionTicket(e, "ticket", i)} />
                                                                    </div>

                                                                </div>
                                                                <div className="col-md-3">
                                                                    <div className="cm-col">
                                                                        <TextField label='Days After Reservation' className="form-control cm-input autoCapitalise custom-disabled-field" type="number" placeholder='Enter Days after reservation' disabled={!isEdit} value={item.daysAfterReservation} name='daysAfterReservation' onChange={(e) => changeOptionTicket(e, "ticket", i)} />
                                                                    </div>

                                                                </div>
                                                                <div className="col-md-3">
                                                                    <div className="cm-col">
                                                                        <TextField label='Days Before Departure' className="form-control cm-input autoCapitalise custom-disabled-field" type="number" placeholder='Enter Days before departure' disabled={!isEdit} value={item.daysBeforeDeparture} name='daysBeforeDeparture' onChange={(e) => changeOptionTicket(e, "ticket", i)} />
                                                                    </div>
                                                                </div>
                                                                
                                                                <div className="col-md-3 d-flex align-items-end">
                                                                    {isEdit &&
                                                                        <div className='setD-flex ms-2'>
                                                                            <Button
                                                                                className="BulkUpdate__removeBtn me-2"
                                                                                onClick={() => handleRemoveTicketDate(i)}
                                                                                disabled={classValues.ticketDates.length === 1}
                                                                            >
                                                                                <i className="fas fa-trash-alt"></i>
                                                                            </Button>

                                                                            {(i === classValues.ticketDates.length - 1 && i<3) && (
                                                                                <Button className='BulkUpdate__AddBtn' onClick={handleAddTicketDate}>
                                                                                    <i className="fas fa-plus-circle"></i>
                                                                                </Button>
                                                                            )}
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </>
                                                        )
                                                    })}
                                                
                                        </div>
                                    </div>
                                </div>

                                {/* <div className="card Tariff__BorderB">
                                    <div className="card-body">
                                        <div className="cm-head-2 mb-4">
                                            <div className="d-flex justify-content-between">
                                                <span className="">Options Maximum</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">VIT</label>
                                                    <input className="form-control cm-input autoCapitalise" type="text" disabled={!isEdit} value={classValues.maxOptionVIT} name='maxOptionVIT' onChange={handleStateChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">SKY</label>
                                                    <input className="form-control cm-input autoCapitalise" type="text" disabled={!isEdit} value={classValues.maxOptionSKY} name='maxOptionSKY' onChange={handleStateChange} />
                                                </div>
                                            </div>

                                            <div className="col-md-3">
                                                <div className="cm-col mt-1">
                                                    <label className="cm-head-label">DFW</label>
                                                    <input className="form-control cm-input autoCapitalise" type="text" disabled={!isEdit} value={classValues.maxOptionDFW} name='maxOptionDFW' onChange={handleStateChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="cm-col mt-1">
                                                    <label className="cm-head-label">FUN</label>
                                                    <input className="form-control cm-input autoCapitalise" type="text" disabled={!isEdit} value={classValues.maxOptionFUN} name='maxOptionFUN' onChange={handleStateChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="cm-col mt-1">
                                                    <label className="cm-head-label">TC</label>
                                                    <input className="form-control cm-input autoCapitalise" type="text" disabled={!isEdit} value={classValues.maxOptionTC} name='maxOptionTC' onChange={handleStateChange} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}

                                {/* <div className="card Tariff__BorderB">
                                    <div className="card-body">
                                        <div className="cm-head-2 mb-4">
                                            <div className="d-flex justify-content-between">
                                                <span className="">Routings</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">Airports Prohibited</label>
                                                    <input className="form-control cm-input autoCapitalise" type="text" disabled={!isEdit} value={classValues.disallowedAirports} name='disallowedAirports' onChange={handleStateChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">Routing Info Source</label>
                                                    <input className="form-control cm-input autoCapitalise" type="text" disabled={!isEdit} value={classValues.classRoutings} name='classRoutings' onChange={handleStateChange} />
                                                </div>
                                            </div>

                                            <div className="col-md-3">
                                                <div className="cm-col mt-1">
                                                    <label className="cm-head-label">Routing</label>
                                                    <input className="form-control cm-input autoCapitalise" type="text" disabled={!isEdit} value={classValues.otherClassOfServices} name='otherClassOfServices' onChange={handleStateChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="cm-col mt-1">
                                                    <label className="cm-head-label">Pax Type Note</label>
                                                    <input className="form-control cm-input autoCapitalise" type="text" disabled={!isEdit} value={classValues.classCodeDesc} name='classCodeDesc' onChange={handleStateChange} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}

                            </TabPanel>

                            <TabPanel value="2" className='m-0 p-0'>
                                <div className="card Tariff__BorderB">
                                    <div className="card-body">
                                        {console.log("classValues.disableAutoTicketing", classValues.disableAutoTicketing, classValues.disablePriceUnitConcept)}
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">Disable auto-ticketing </label>
                                                    <div className="cm-radio-inline custom-disabled-field">
                                                        <FormControlLabel control={<Radio color="primary" disabled={!isEdit} checked={((classValues.disableAutoTicketing) == true || (classValues.disableAutoTicketing) == "true")} name='disableAutoTicketing' value={(true)} onChange={handleStateChange} />} label="True" />
                                                        <FormControlLabel control={<Radio color="primary" disabled={!isEdit} checked={(((classValues.disableAutoTicketing) == false || (classValues.disableAutoTicketing) == "false"))} name='disableAutoTicketing' value={(false)} onChange={handleStateChange} />} label="False" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">PUC allowed</label>
                                                    <div className="cm-radio-block custom-disabled-field">
                                                        <FormControlLabel control={<Radio color="primary" disabled={!isEdit} checked={(classValues.disablePriceUnitConcept == "true" || (classValues.disablePriceUnitConcept) == true)} name='disablePriceUnitConcept' value={true} onChange={handleStateChange} />} label="True" />
                                                        <FormControlLabel control={<Radio color="primary" disabled={!isEdit} checked={((classValues.disablePriceUnitConcept == "false" || (classValues.disablePriceUnitConcept) == false))} name='disablePriceUnitConcept' value={false} onChange={handleStateChange} />} label="False" />
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="col-md-3">
                                                <div className="cm-col custom-disabled-field">
                                                    <label className="cm-head-label"></label>
                                                    <FormControlLabel control={<Checkbox disabled={!isEdit} checked={(classValues.issueAsBulk == true || classValues.issueAsBulk == "true")} name='issueAsBulk' value={(classValues.issueAsBulk == true || classValues.issueAsBulk == "true" ? false : true)} onChange={handleStateChange} />} label="Issue ticket as bulk only" />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">Pax Type <span className='bd-errorMsg'>*</span></label>
                                                    <div className="cm-radio-inline custom-disabled-field">
                                                        <FormControlLabel sx={{ marginRight: '10px' }} control={<Radio color="primary" disabled={!isEdit} checked={classValues.searchFareBy == "ADT public"} name='searchFareBy' value={'ADT public'} onChange={handleStateChange} />} label="ADT Public" />
                                                        <FormControlLabel sx={{ marginRight: '0' }} control={<Radio color="primary" disabled={!isEdit} checked={classValues.searchFareBy == "ADT prive"} name='searchFareBy' value={'ADT prive'} onChange={handleStateChange} />} label="ADT Private" />
                                                    </div>
                                                    <div className="cm-radio-inline custom-disabled-field">
                                                        <FormControlLabel control={<Radio color="primary" disabled={!isEdit} checked={classValues.searchFareBy == "JCB"} name='searchFareBy' value={'JCB'} onChange={handleStateChange} />} label="JCB" />
                                                        <FormControlLabel control={<Radio color="primary" disabled={!isEdit} checked={classValues.searchFareBy == "PFA"} name='searchFareBy' value={'PFA'} onChange={handleStateChange} />} label="PFA" />
                                                        <FormControlLabel control={<Radio color="primary" disabled={!isEdit} checked={classValues.searchFareBy == "ITX"} name='searchFareBy' value={'ITX'} onChange={handleStateChange} />} label="ITX" />
                                                    </div>
                                                </div>
                                                {mandatoryFields?.searchFareBy &&
                                                    <div className='bd-errorMsg'>This field is required.</div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card Tariff__BorderB">
                                    <div className="card-body">
                                        <div className="cm-head-2 mb-4">
                                            <div className="d-flex justify-content-between">
                                                <span>Account Code</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    {/* <label className="cm-head-label">INTAIR</label> */}
                                                    <TextField label='INTAIR' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" disabled={!isEdit} value={classValues.accountIntair} name='accountIntair' onChange={handleStateChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    {/* <label className="cm-head-label">SKYLINK </label> */}
                                                    <TextField label='SKYLINK' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" disabled={!isEdit} value={classValues.accountSkyline} name='accountSkyline' onChange={handleStateChange} />
                                                </div>
                                            </div>

                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    {/* <label className="cm-head-label">DFW</label> */}
                                                    <TextField label='DFW' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" disabled={!isEdit} value={classValues.accountDFW} name='accountDFW' onChange={handleStateChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    {/* <label className="cm-head-label">FUN SUN</label> */}
                                                    <TextField label='FUN SUN' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" disabled={!isEdit} value={classValues.accountSUNFUN} name='accountSUNFUN' onChange={handleStateChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    {/* <label className="cm-head-label">TC</label> */}
                                                    <TextField label='TC' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" disabled={!isEdit} value={classValues.accountTC} name='accountTC' onChange={handleStateChange} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-body">
                                        <div className="cm-head-2 mb-4">
                                            <div className="d-flex justify-content-between">
                                                <span>Ticket Designator</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    {/* <label className="cm-head-label">INTAIR</label> */}
                                                    <TextField label='INTAIR' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" disabled={!isEdit} value={classValues.ticketIntair} name='ticketIntair' onChange={handleStateChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    {/* <label className="cm-head-label">SKYLINK </label> */}
                                                    <TextField label='SKYLINK' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" disabled={!isEdit} value={classValues.ticketSkyline} name='ticketSkyline' onChange={handleStateChange} />
                                                </div>
                                            </div>

                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    {/* <label className="cm-head-label">DFW</label> */}
                                                    <TextField label='DFW' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" disabled={!isEdit} value={classValues.ticketDFW} name='ticketDFW' onChange={handleStateChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    {/* <label className="cm-head-label">FUN SUN</label> */}
                                                    <TextField label='FUN SUN' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" disabled={!isEdit} value={classValues.ticketSUNFUN} name='ticketSUNFUN' onChange={handleStateChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    {/* <label className="cm-head-label">TC</label> */}
                                                    <TextField label='TC' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" disabled={!isEdit} value={classValues.ticketTC} name='ticketTC' onChange={handleStateChange} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </TabPanel>
                            {/* <TabPanel value="3" className='m-0 p-0'>
                                <div className="card Tariff__BorderB">
                                    <div className="card-body">
                                        <div className="cm-head-2 mb-4">
                                            <div className="d-flex justify-content-between">
                                                <span>English</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">INTAIR</label>
                                                    <input className="form-control cm-input autoCapitalise" type="text" disabled={!isEdit} value={classValues.enRemarkIntair} name='enRemarkIntair' onChange={handleStateChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">SKY </label>
                                                    <input className="form-control cm-input autoCapitalise" type="text" disabled={!isEdit} value={classValues.enRemarkSkyline} name='enRemarkSkyline' onChange={handleStateChange} />
                                                </div>
                                            </div>

                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">DFW</label>
                                                    <input className="form-control cm-input autoCapitalise" type="text" disabled={!isEdit} value={classValues.enRemarkDFW} name='enRemarkDFW' onChange={handleStateChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">FUN</label>
                                                    <input className="form-control cm-input autoCapitalise" type="text" disabled={!isEdit} value={classValues.enRemarkSUNFUN} name='enRemarkSUNFUN' onChange={handleStateChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">TC</label>
                                                    <input className="form-control cm-input autoCapitalise" type="text" disabled={!isEdit} value={classValues.enRemarkTC} name='enRemarkTC' onChange={handleStateChange} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card Tariff__BorderB">
                                    <div className="card-body">
                                        <div className="cm-head-2 mb-4">
                                            <div className="d-flex justify-content-between">
                                                <span>French</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">INTAIR</label>
                                                    <input className="form-control cm-input autoCapitalise" type="text" disabled={!isEdit} value={classValues.frRemarkIntair} name='frRemarkIntair' onChange={handleStateChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">SKY </label>
                                                    <input className="form-control cm-input autoCapitalise" type="text" disabled={!isEdit} value={classValues.frRemarkSkyline} name='frRemarkSkyline' onChange={handleStateChange} />
                                                </div>
                                            </div>

                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">DFW</label>
                                                    <input className="form-control cm-input autoCapitalise" type="text" disabled={!isEdit} value={classValues.frRemarkDFW} name='frRemarkDFW' onChange={handleStateChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">FUN</label>
                                                    <input className="form-control cm-input autoCapitalise" type="text" disabled={!isEdit} value={classValues.frRemarkSUNFUN} name='frRemarkSUNFUN' onChange={handleStateChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">TC</label>
                                                    <input className="form-control cm-input autoCapitalise" type="text" disabled={!isEdit} value={classValues.frRemarkTC} name='frRemarkTC' onChange={handleStateChange} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </TabPanel> */}
                            <TabPanel value="4" className='m-0 p-0'>
                                <div className="card ">
                                    <div className="card-body">

                                        <div className="d-flex justify-content-between">
                                            <button className="cm-yellow-btn mb-5" onClick={() => { history.push(`/newPrix?tariff=${tarifValues?.tarifKey}+&class=${classValues?.clasKey}`); dispatch(setPrixDetails({})) }}>+ Create New Prix</button>
                                        </div>

                                        {!createNew && prixApiCallLoader ? <>...Loading</> : prixArray && prixArray.map((item, i) => {
                                            return (<div>
                                                <div className="Tariff_classCard__main" onClick={() => prixDetailsOnclick(item?.prixKey, classValues, tarifValues)}>
                                                    <div className="Tariff_classCard__Left">
                                                        <div className="Tariff_classCard__alert">
                                                            <span>P</span>
                                                        </div>
                                                        <div className="Tariff_classCard__Right">
                                                            <div className='Tariff_classCard'>
                                                                <span className="Tariff_classCard_mainTitle"> Validity: </span>
                                                                <span className="Tariff_classCard_mainTitle"> 
                                                                    {`${moment.utc(item?.validFrom).format("DD-MMM-yyyy")} to ${moment.utc(item?.validTo).format("DD-MMM-yyyy")}`}
                                                                </span>
                                                            </div>
                                                            <div className='Tariff_classCard'>
                                                                <span className="Tariff_classCard_subTitle">Our Comm: </span>
                                                                <span className="Tariff_classCard_mainTitle"> {item.commissionPercentage}</span></div>
                                                            <div className='Tariff_classCard'><span className="Tariff_classCard_subTitle">Agency Comm:</span>
                                                                <span className="Tariff_classCard_mainTitle">{item.passBackCommission}</span></div>
                                                            <div className='Tariff_classCard'><span className="Tariff_classCard_subTitle"> Markup:  </span>
                                                                <span className="Tariff_classCard_mainTitle mr-18">{item.markup} </span></div>
                                                            <div className='Tariff_classCard'><span className="Tariff_classCard_subTitle">Tour Code:</span>
                                                                <span className="Tariff_classCard_mainTitle">
                                                                    {/* {item && item.tourCode && item.tourCode.length > 0 && item?.tourCode?.map((item)=>{
                                                                    return(
                                                                        <>
                                                                        {item.tourCodes}, 
                                                                        </>
                                                                    )
                                                                })} */}
                                                                    {item?.tourCode?.[0]?.tourCodes}
                                                                </span>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>)

                                        })}
                                    </div>
                                </div>
                            </TabPanel>
                        </TabContext>
                        {isEdit &&
                            <Box className="cm-card-edit" sx={{ background: '#FFF4DE', padding: '16px', mb: '0' }}>
                                <button className="cm-secondary-btn mr-2" type="button" onClick={cancelClick}>Cancel</button>
                                <button className="cm-primary-btn mr-2" onClick={() => saveClass()}><i className='fa fa-save mr-1'></i> Save</button>
                                {/* {createNew && <button className="cm-primary-btn mr-2" onClick={()=>createMultipleClasses()}>Create Multiple Classes</button>}
                                {createNew && <button className="cm-primary-btn" onClick={()=>createNewClassAndNewPrix()}>Next</button>} */}
                            </Box>}
                    </Box>
                </div>
            </div >
            </>
            }
        </>
    )
}

export default NewClass